import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { observer } from 'mobx-react-lite'
import type ConsultationSchedulerViewModel from '../../ConsultationSchedulerViewModel'
import { Button } from '@/components/Button'

interface AvailabilitySubmittedDialogContainerProps {
  vm: ConsultationSchedulerViewModel
}

export const AvailabilitySubmittedDialogContainer = observer(
  function AvailabilitySubmittedDialogContainer({
    vm,
  }: AvailabilitySubmittedDialogContainerProps) {
    const testId = 'availability-submitted-dialog'
    return (
      <ModalDialog
        size="lg"
        isOpen={vm.availabilitySubmittedDialog.showing}
        onClose={vm.close}
        testId={testId}
      >
        <ModalDialogHeader>
          <ModalDialogTitle>Availability submitted!</ModalDialogTitle>
          <ModalDialogDescription>
            Your Pro will confirm your appointment time. We'll notify you once
            it's scheduled.
          </ModalDialogDescription>
        </ModalDialogHeader>
        <ModalDialogFooter>
          <ModalDialogActions>
            <Button
              label="Got it"
              onPress={() => vm.availabilitySubmittedDialog.close()}
              testId={`${testId}-done-button`}
            />
          </ModalDialogActions>
        </ModalDialogFooter>
      </ModalDialog>
    )
  },
)
